import React, { Component } from "react";
import Logo from "../../shared/logo";
import SignInFooter from "../../shared/footer/signinFooter";

import { withRegistration } from "../../shared/containers/containerRegistration";
import Preloader from "../../shared/items/static/preloader";
import ButtonRegistrationWrapper from "./ButtonRegistrationWrapper";

import styles from "./registration.module.scss";
import RegistrationForm from "./RegistrationForm";
import RegistrationValidateResuld from "./RegistrationValidateResuld";
import { states } from "../../reducers/queriesStates";

let interval = null;

class Registration extends Component {
  constructor(props) {
    super(props);

    this.state = {
      timoutLinkMessage: null,
      registrationCompleted: null,
      count: 3,
    };
  }

  componentDidMount() {
    const { onGetRegistration, onHandleChangeStore } = this.props;
    const token = window.location.search.replace("?token=", "");

    onHandleChangeStore("token", token);
    onGetRegistration({ token });
  }

  componentDidUpdate(prevProps) {
    const { registration } = this.props;

    if (registration.registrationUserDataState === states.FAILURE && prevProps.registration.registrationUserDataState === states.REQUEST) {
      this.setState({ timoutLinkMessage: registration.errors });
    }

    if (registration.dataState === states.READY && prevProps.registration.dataState === states.REQUEST) {
      const toSignIn = () => {
        const { count } = this.state;
        if (count === 0) {
          clearInterval(interval);
          window.open(window.location.origin, "_self");
        } else {
          this.setState({ count: count - 1, registrationCompleted: `Переход на страницу входа ${count}` });
        }
      };

      interval = setInterval(toSignIn, 1500);
    }
  }

  render() {
    const { registration } = this.props;
    const { timoutLinkMessage, registrationCompleted } = this.state;

    return (
      <div className={styles.registrationWrapper}>
        <div className={styles.registrationForm}>
          <div className={styles.logo_container}>
            <Logo />
          </div>

          {registration.registrationUserDataState === states.FAILURE ? (
            <div className={styles.timoutLinkMessage}>{timoutLinkMessage}</div>
          ) : null}

          {registrationCompleted !== null ? (
            <div className={styles.registrationCompleted}>
              <div>Регистрация успешна</div>
              <div>{registrationCompleted}</div>
            </div>
          ) : null}

          {registration.registrationUserDataState === states.REQUEST ? (
            <div style={{ display: "flex", justifyContent: "center", marginBottom: "30px" }}>
              <Preloader />
            </div>
          ) : null}

          {registration.registrationUserDataState === states.READY && registration.dataState !== states.READY ? (
            <div>
              {registration.registrationUser.email !== undefined ? (
                <div className={styles.registrationLogin}><b>Ваш логин:</b></div>
              ) : null}
              <RegistrationForm email={registration.registrationUser.email} />

              <div className={styles.button_container}>
                <ButtonRegistrationWrapper />
              </div>
            </div>
          ) : null}

          <RegistrationValidateResuld />
        </div>

        <SignInFooter />
      </div>
    );
  }
}

export default withRegistration(Registration);
